import React, {Component} from 'react';
import Message from './Message';
import _ from 'lodash';
import { Col } from 'react-bootstrap';

class MessageList extends Component {
  constructor(props){
    super(props);
    this.state = {
      messages: []
    };
    let app = this.props.db.database().ref('messages');
    app.on('value', snapshot => {
      this.getData(snapshot.val());
    });
  }

  getData(values){
    let messagesVal = values;
    let messages = _(messagesVal)
                      .keys()
                      .map(messageKey => {
                          let cloned = _.clone(messagesVal[messageKey]);
                          cloned.key = messageKey;
                          return cloned;
                      })
                      .value();
      this.setState({
        messages: messages
      });
  }

  render() {
    let messageNodes = this.state.messages.map((message, i) => {
      if(message.isValidated === undefined || message.isValidated === 1 ){
      return (
        
        <div key={i} className='jumbotron-like'>
            <Message message = {message.message} />
            </div>
            
      )
    }
    });
    return (
        
        <Col sm={6} smOffset={3}>
          <h3>Messages</h3>
        {messageNodes}
        </Col>
    );
  }
}

export default MessageList